var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.currentMode == _vm.modes.LOAD)?_c('Loader',{on:{"loaded":_vm.protoLoaded}}):_c('Renderer',{attrs:{"pkg":_vm.protoPackage,"messages":_vm.protoMessages},on:{"newProto":_vm.loadNewProto}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }